export default __webpack_public_path__ + "static/media/MONGGA LOGO WHITEE 1.18a05719.png";